function initSliderHistoryAboutUs() {

  var SliderAboutUs = $('.slider-about-us');
  if (SliderAboutUs.length <= 0) {
    return;
  }

  var LinkSliderAboutUsDate = $('.link-slider-about-us-date');
  if (LinkSliderAboutUsDate.length <= 0) {
    return;
  }

  // Init slider
  SliderAboutUs.slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    draggable: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: true
        }
      }
    ]
  });


  // Click sulle date
  LinkSliderAboutUsDate.on('click', function () {
    var self = $(this);
    if (self.hasClass('active')) {
      return;
    }
   
    var dateSelected = self.text();
    console.log(dateSelected);

    var dateContent = $('.history-active').attr('data-history');
    console.log(dateContent);

    LinkSliderAboutUsDate.removeClass('active');
    self.addClass('active');

    selectHistory(dateSelected);
  });

  function selectHistory(dt){
    $(".history-content").each(function(){
      if ($(this).attr('data-history') == dt) {
        $(this).addClass("history-active");
      } else if ($(this).hasClass("history-active")) {
        $(this).removeClass("history-active");
      }
    });
  }
}